import React, {useState, useEffect} from 'react';
import { Redirect } from "react-router-dom";

import { Typography, Spin, Row, Col, Divider, Form, Input, InputNumber, Select, DatePicker, Switch, Button, Checkbox } from 'antd';

import WasteTypeSelect from '../../../../components/WasteTypeSelect';
import MeasurementUnitSelect from '../../../../components/MeasurementUnitSelect';

import './index.less';

const { Title } = Typography;

const layout = {
  labelCol: { span: 6, offset: 1 },
  wrapperCol: { span: 14 },
};

const validateMessages = {
  required: '${label} é obrigatório!',
  types: {
    email: '${label} is not a valid email!',
    number: '${label} is not a valid number!',
  },
  number: {
    range: '${label} must be between ${min} and ${max}',
  },
};

export default ({}) => {
    const [wasteTypes, setWasteTypes] = useState([]);
    const [measurementUnits, setMeasurementUnits] = useState([]);
    const [loading, setLoading] = useState(false);
    useEffect(()=> {
        setLoading(false);
    }, []);
    const onFinish = (values) => {
        console.log(values);
    };
    return (
        <div className="waste__to-produce">
          <Title level={2}>Resíduos a Produzir</Title>
          <Divider />
          <Form {...layout} onFinish={onFinish} validateMessages={validateMessages}>
            <Form.Item name={'waste_type_uid'} label="Tipo de Resíduo" rules={[{ required: true }]}>
              <WasteTypeSelect />
            </Form.Item>
            <Form.Item label="Quantidade">
              <Input.Group compact>
                <Form.Item name={'amount'} label="Quantidade" noStyle rules={[{ required: true }]}>
                  <InputNumber />
                </Form.Item>
                <Form.Item name={'measurement_unit_uid'} label="Unidade de Medida" noStyle rules={[{ required: true }]}>
                  <MeasurementUnitSelect/>
                </Form.Item>
              </Input.Group>
            </Form.Item>
            <Form.Item label="Morada">
              <Input.Group compact>
                <Form.Item name={'address'} label="Morada" noStyle rules={[{ required: true }]}>
                  <Input />
                </Form.Item>
                <Input.Group compact>
                  <Form.Item name={'postal-code'} label="Código Postal" noStyle rules={[{ required: true }]}>
                    <Input placeholder="Código Postal" style={{ width: '150px' }} />
                  </Form.Item>
                  <Form.Item name={'city'} label="Localidade" noStyle rules={[{ required: true }]}>
                    <Select placeholder="Localidade" style={{ width: 'auto' }}>
                      <Select.Option value="1">Test</Select.Option>
                    </Select>
                  </Form.Item>
                </Input.Group>
                <Form.Item name={'state'} label="Distrito" noStyle rules={[{ required: true }]}>
                  <Select placeholder="Distrito">
                    <Select.Option value="1">Test</Select.Option>
                  </Select>
                </Form.Item>
              </Input.Group>
            </Form.Item>
            <Form.Item name={'date'} label="Data Estimada" rules={[{ required: true }]}>
              <DatePicker />
            </Form.Item>
            <Form.Item name={'transport'} label="Transporte Próprio">
              <Switch />
            </Form.Item>
            <Form.Item wrapperCol={{ offset: 7, span: 14 }}>
              <Button type="primary" htmlType="submit">
                Enviar
              </Button>
            </Form.Item>
          </Form>
        </div>
    );
}
